import { defineStore } from 'pinia';
import { createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { findIfPassesByGroups } from '~/utils/strapiComponents/filters';
import { strapi } from '../transport/strapi';
import type { IPaymentSystemImages, IPaymentSystemImagesStrapiResponse } from '~/types/payments';

export const useStorePaymentSystemImages = defineStore('paymentSystemImages', {
  state: () => ({
    data: [] as IPaymentSystemImages[],
    requestPromise: null as Promise<IPaymentSystemImagesStrapiResponse> | null,
  }),

  getters: {
    activePaymentImages(state) {
      return state.data;
    },
    find() {
      return (methodLogoId: string) => {
        return this.activePaymentImages.find((data) => data.methodLogoId === methodLogoId) || null;
      };
    },
    findPresetAmounts() {
      return (methodId?: string) => {
        const payment = this.activePaymentImages.find((data) => data.methodLogoId === methodId);
        if (payment) {
          return payment.presetAmounts?.filter((p) => {
            return findIfPassesByGroups(p.includedGroups || '', p.excludedGroups || '');
          });
        }
      };
    },
  },

  actions: {
    async loadPaymentSystemImages(): Promise<boolean> {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'paymentProviderLogo',
          'presetAmounts',
          'paymentBonusLabel',
        ]);

        this.requestPromise = strapi()
          .get('payment-system-images', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response.data) {
        const filteredState = this.data.filter(
          (item) => !response?.data.find(({ id }) => id && id === item.id)
        );

        this.data = [...filteredState, ...response?.data];

        return true;
      } else {
        return false;
      }
    },
  },
});
